module.exports = __webpack_public_path__ + "img/root.f7740f40.png";